module["exports"] = [
  "(0###) #########",
  "(0####) #######",
  "+49-###-#######",
  "+49-####-########"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de/phone_number/formats.js
// module id = 2479
// module chunks = 1609